export const SET_TEMPORARY_TRIGGERS_TABLE = 'SET_TEMPORARY_TRIGGERS_TABLE';

export const setTemporaryTriggersTable = (triggersTable: any) => ({
  type: SET_TEMPORARY_TRIGGERS_TABLE,
  temporaryTriggersTable: triggersTable,
});
